import { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { BsInbox, BsSearch } from "react-icons/bs";
import IntegrationDetails from "./IntegrationDetails";
import UseToggle from "../../../Hooks/UseToggle";
import { superAdminMetaServices } from "../../../APIServices/MetaManagement/superAdminMetaServices";

const Integration = () => {
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("new");
  const [integrationId, setIntegrationId] = useState("");
  const [integrations, setIntegrations] = useState([]);
  const toggles = UseToggle();

  const getIntegrationList = async () => {
    setLoader(true)
    let data = await superAdminMetaServices.getIntegrationList(search, filter, sort)
    setIntegrations(data?.data || [])
    setLoader(false)
  }

  useEffect(() => {
    getIntegrationList()
  }, [search, filter, sort]);
  
  return (
    <>
      <div className="h-100 d-flex flex-column">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="d-flex align-items-center gap-2">
            <div className="select-with-icon">
              <span className="select-icon">
                <BsInbox />
              </span>
              <Form.Select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                size="sm" className="bg-light">
                <option value="">All</option>
                <option value="Messaging">Messaging</option>
                <option value="E-Commerce">E-Commerce</option>
                <option value="CMS">CMS</option>
              </Form.Select>
            </div>
            <div className="position-relative">
              <BsSearch className="search-icon" />
              <Form.Control
                size="sm"
                placeholder="Search..."
                className="search-input"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
            <div className="select-with-icon">
              <span className="select-icon">
                <BsInbox />
              </span>
              <Form.Select
                onChange={(e) => setSort(e.target.value)}
                value={sort}
                size="sm" className="bg-light">
                <option value="new">New</option>
                <option value="a-z">A-Z</option>
              </Form.Select>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-3">
            {integrations?.map(((item, index) => (
              <Col key={index} xxl={3} xl={4} lg={6} md={6} sm={6}>
                <div className="ribbon-wrapper overflow-hidden">
                  {item?.type  &&
                    <span className={`ribbon ${item?.type === "published" ? "bg-success" : "bg-primary"}`}>{item?.type === "comingSoon"  ? "Coming Soon" : "Activated"}</span>
                  }
                  <Card className="border h-100 addon-card CP text-center" title="WordPress | CMS" onClick={() => { toggles.setToggle(); setIntegrationId(item?.integrationId) }}>
                    <Card.Body>
                      <img src={item?.icon} alt="Wordpress" style={{ height: 60 }} />
                      <Card.Title className="fw-bold mt-3 m-0" style={{ fontSize: 16 }}>{item?.title}</Card.Title>
                      <Card.Text className="text-muted" style={{ fontSize: 13 }}>{item?.subTitle}</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            )))}
          </Row>
        </div>
      </div>
      <IntegrationDetails
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        integrationId={integrationId}
      />
    </>
  );
};

export default Integration;
